import React from "react";
import { RISK_CONFIG } from "@/lib/format";

export function RiskBadge({ level, testid }) {
  const c = RISK_CONFIG[level] || RISK_CONFIG.LOW;
  return (
    <span data-testid={testid} className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${c.cls}`}>
      {c.label}
    </span>
  );
}
